import './App.css';
import {LawPage, Layout} from './Components/index';
import {Routes, Route} from 'react-router-dom'
import {AskConsult, CreatePost, CreateRule, EditPost, Homepage, IndexPage, PostPage, RegisterPage, RolesPage, Team, EditRule, SubsList, CreateMember, EditMember, Fields, Firms, Property, Conflict, Copywrites, Employee, Taxes, TagPostsPage, Contact, Laws, LawnexSection, AppointmentPage, Dashboard, AppointmentsManag, CaseQuery, CaseDashboard} from './sections/index';

function App() {
  return (
    <Routes>
          <Route path='/register' element={<RegisterPage />}/>
          <Route path='/laws' element={<Laws />} />
      <Route path="/" element={<Layout/>}>
          <Route path='/' element={<Homepage />}/>
          <Route path='/team' element={<Team />}/>
          <Route path='/articles' element={<IndexPage />}/>
          <Route path='/rules' element={<RolesPage />}/>
          <Route path='/create' element={<CreatePost />}/>
          <Route path='/createMember' element={<CreateMember />}/>
          <Route path='/askConsults' element={<AskConsult />}/>
          <Route path="/post/:id" element={<PostPage />} />
          <Route path='/edit/:id' element={<EditPost />}/>
          <Route path='/editMember/:id' element={<EditMember />}/>
          <Route path='/editrule/:id' element={<EditRule />}/>
          <Route path='/subsList' element={<SubsList />}/>
          <Route path='/appointmentManag' element={<AppointmentsManag/>}/>
          <Route path='/dashboard' element={<Dashboard />}/>
          <Route path='/fields' element={<Fields />}/>
          <Route path='/firms' element={<Firms />}/>
          <Route path='/property' element={<Property />}/>
          <Route path='/conflict' element={<Conflict />}/>
          <Route path='/copywrites' element={<Copywrites />}/>
          <Route path='/employee' element={<Employee />}/>
          <Route path='/taxes' element={<Taxes />}/>
          <Route path='/CaseQuery' element={<CaseQuery/>} />
          <Route path='/CaseDash' element={<CaseDashboard/>} />
          <Route path='/lawnex' element={<LawnexSection />}/>
          <Route path="/tags/:tag" element={<TagPostsPage />} />
          <Route path="/Contact" element={<AskConsult />} />
          <Route path="/law/:lawId" element={<LawPage />} />
          <Route path="/appointments" element={<AppointmentPage />} />
      </Route>
    </Routes>
    
  );
}

export default App;
